/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */
import React from "react";
// import { LazyLoadImage } from 'react-lazy-load-image-component';
import Draggable from 'react-draggable';
import PropTypes from "prop-types";
import PipelineModal from "../pipeline-modal";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Swiper from 'swiper/swiper-bundle.min.js'
import axios from "axios/dist/axios.min.js";
import utils from "../../utils/utils";
import "./style.less";
import 'swiper/swiper.less';
import px2rem from "../../utils/px2rem";

class PipelineImgHotMap extends React.Component {
  constructor(props) {
    let clientWidth = 375;
    if (typeof window !== 'undefined') {
      clientWidth = window.document.body.clientWidth;
    }
    const screenRatio = (clientWidth) / 375;
  
    super(props);
    this.state = {
      listHrefConfig: {},
      dragMode: false, // 当前模式，包括编辑和展示两种模式
      modalVisibles: [],
      isIframe: utils.getParams('isIframe') == 1,
      inSwitchTabIndex: props.tabIndex || 0
    };
    this.swiper = null;
    this.screenRatio = screenRatio;
    this.isIphoneX = utils.isIphoneX();
  }

  componentDidMount() {
    const { baseConfig } = this.props.config;
    this.getProductInfo();

    if (baseConfig.openSwiper === '是') {
      this.initImgHotMapSwiper();
    }

    if (typeof window !== 'undefined' && window.self !== window.top) {
      window.addEventListener('message', this.receivePostMessageFromEditor);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.dragMode !== prevState.dragMode) {
      this.initImgHotMapSwiper();
    }
  }

  componentWillUnmount() {
    if (typeof window !== 'undefined' && window.self !== window.top) {
      window.removeEventListener('message', this.receivePostMessageFromEditor);
    }
  }

  receivePostMessageFromEditor = (event) => {
    const data = event.data || {};
    const msgType = data.msgType;
    if (msgType === 'checkToBaseConfig') {
      this.setState({
        dragMode: false,
      })
    }
    if (msgType === 'componentSelect') {
      const currentComponent = data.currentComponent;
      if (!currentComponent) {
        return;
      }
      // 编辑器切换组件之后，根据postMessage返回id，确认是否当前组件来切换模式
      if (currentComponent.id && this.props.customAttributes["data-component-block"].indexOf(currentComponent.id) > -1) {
        this.setState({
          dragMode: true,
        })
      } else {
        this.setState({
          dragMode: false,
        })
      }
    }
  }

  getProductInfo = () => {
    const promiseList = this.props.config.itemList.map((item, index) => {
      let promiseItem;
      if (item.linkType === '链接跳转') {
        promiseItem = {
          index,
          href: item.link,
        }
      } else {
        let reqUrl = '';
        if (item.linkType === "商品id") {
          reqUrl =
            "https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/goods/info?access_token=znSnA7pxO35wtPBaur";
        } else if (item.linkType === "配色id") {
          reqUrl =
            "https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/style/info?access_token=znSnA7pxO35wtPBaur";
        } else if (item.linkType === "skuId") {
          reqUrl =
            "https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/sku/info?access_token=znSnA7pxO35wtPBaur";
        }
        promiseItem = new Promise((resolve) => {
          const id = Number(item.id);
          const linkType = item.linkType;
          axios({
            url: reqUrl,
            method: 'post',
            withCredentials: true,
            data: {
              ids: [id],
              from: this.props.specialApiFrom
            }
          }).then(res => {
            let productItem = {
              linkType,
              index
            }
            if (res.data.status === 0 && res.data.data.List && res.data.data.List[0]) {
              Object.assign(productItem, {
                id: res.data.data.List[0].id,
                href: res.data.data.List[0].url,
              });
            }
            resolve(productItem);
          })
        })
      }
      return promiseItem;
    })

    // 记录返回的商品url
    Promise.all(promiseList).then(resList => {
      const listHrefConfig = this.state.listHrefConfig;
      resList.forEach(item => {
        listHrefConfig[item.index] = item;
      })
      this.setState({
        listHrefConfig,
      })
    })
  }

  handleItemClick = (index, item) => {
    // 当选择的点击事件是弹窗
    if (item.linkType === '唤起弹窗') {
      const { modalVisibles } = this.state;
      modalVisibles[index] = true
      this.setState({
        modalVisibles
      });
      return;
    } else if (item.linkType === '发布笔记') {
      if (utils.SHDiffVersion(utils.getVersion(), '7.88.0')) {
        const publishRoute = `shihuo://www.shihuo.cn?route=attendColumn&column_id=${item.id}&&column_name=${encodeURIComponent(item.topicName)}&from=10&need_login=true&needInterceptor=true`;
        window.Jockey.send('action', {
          url: publishRoute
        });
      } else {
        const jumpUrl = `shihuo://www.shihuo.cn?route=topicList&column_id=${item.id}&sort=1`
        utils.jumpToUrl(this.props.routeParams, jumpUrl, jumpUrl, {}, -1, this.props, false);
      }
      return;
    }

    const href = this.state.listHrefConfig[index].href;
    if (this.props.templateName === 'toufang') {
      utils.handleToufangClick({
        link: href,
        props: this.props,
        index
      })
      return
    }

    const baseConfig = this.props.config.baseConfig;

    const options = {
      link: href,
      type: baseConfig.sortType,
      name: item.title,
      sort: index
    };
    const convertUrl = utils.convertHref(href);
    utils.jumpToUrl(this.props.routeParams,convertUrl,href, options, -1,this.props,false);
  }

  productBannerGo = (url) => {
    if (this.props.templateName === 'toufang') {
      utils.handleToufangClick({
        link: url,
        props: this.props,
      })
      return
    }

    // 商品banner跳转
    const options = {};
    const convertUrl = utils.convertHref(url);
    utils.jumpToUrl(this.props.routeParams,convertUrl,url,options,-1,this.props,false);
  }

  // 初始化swiper
  initImgHotMapSwiper = () => {
    if (this.swiper) {
      this.swiper.destroy();
    }
    if (this.swiperRef) {
      const { baseConfig } = this.props.config;
      const options = {
        spaceBetween: 54,
        centeredSlides: true,
        autoplay: {
          disableOnInteraction: false,
          delay: 2000,
        },
        loop: true,
        allowTouchMove: false,
        simulateTouch: true,
        touchStartPreventDefault: false,
        on: {
          click: () => {
            const { listHrefConfig } = this.state;
            const realIndex = this.swiper.realIndex;
            const target = listHrefConfig[realIndex];
            const url = target.href;
            if (url) {
              const options = {
                link: url,
                type: 'swiper',
                sort: realIndex
              };
              const ptiOptions = {
                bizExtra: {
                  goods_id: target.linkType === '商品id' ? target.id : '',
                  style_id: target.linkType === '配色id' ? target.id : '',
                  sku_id: target.linkType === 'skuId' ? target.id : '',
                }
              }
              const convertUrl = utils.convertHref(url);
              utils.jumpToUrl(this.props.routeParams, convertUrl, url, options, -1, this.props, false, ptiOptions);
            }
          }
        }
      }

      if (baseConfig.direction === '垂直方向') {
        options['direction'] = 'vertical';
      }

      if (baseConfig.effect === '淡入淡出') {
        options['effect'] = 'fade';
        options['fadeEffect'] = {
          crossFade: true, // 启用交叉淡入淡出
        }
      }

      this.swiper = new Swiper(this.swiperRef, options); 
    }
  }

  handleDragEnd = (type, index, event, position) => {
    // 拖拽结束，将位置信息发送到编辑器
    const data = {
      left: String(position.x),
      top: String(position.y),
    };
    this.updateDragItemMessage(data, type, index);
  }

  handleItemResize = (type, index, event) => {
    const itemEl = event.currentTarget;
    const data = {
      width: String(itemEl.clientWidth),
      height: String(itemEl.clientHeight),
    };
    this.updateDragItemMessage(data, type, index);

    if (this.props.config.baseConfig.openSwiper === '是') {
      this.initImgHotMapSwiper();
    }
  }

  updateDragItemMessage = (data, type, index) => {
    if (typeof window !== 'undefined' && window.parent) {
      try {
        window.parent.postMessage({
          componentId: this.props.customAttributes["data-component-id"],
          msgType: 'updateDrag',
          type,
          index,
          data,
        }, '*');
      } catch(err) {
        console.log(err);
      }
    }
  }

  transformPx = (num) => {
    // 对单位进行转换
    num = Number(num);
    if (isNaN(num)) {
      num = 0;
    }
    const realNum = Math.round(num * this.screenRatio);
    return realNum;
  }

  // 常规热区
  renderNormalHotMap() {
    const { modalVisibles } = this.state
    const { allModals = [] } = this.props
    const { baseConfig, itemList = [] } = this.props.config;
    return (
      <div className="drag-editor-container">
        {
          itemList.map((item, index) => {
            const width = this.transformPx(item.width);
            const height = this.transformPx(item.height);
            const left = this.transformPx(item.left);
            const top = this.transformPx(item.top);

            // 当点击事件选择的是弹窗
            const targetModal = allModals.find(value => value.id === item.targetModal)
            return (
              <div key={`item_${index}`} style={{width: '100%', height: '100%'}}>
                <Draggable
                  disabled={!this.state.dragMode}
                  defaultPosition={{ x: Number(left), y: Number(top) }}
                  bounds="parent"
                  handle=".handle"
                  onStop={this.handleDragEnd.bind(this, 'normal', index)}
                >
                  {this.state.dragMode ?
                    (
                      <div
                        className="edit-drag-item"
                        style={{
                          width: `${width}px`,
                          height: `${height}px`,
                          zIndex: index + 100,
                          borderColor: baseConfig.dragFrameColor
                        }}
                        onClick={this.handleItemResize.bind(this, 'normal', index)}
                      >
                        <div className="handle"></div>
                        <img className="item-img"src={utils.formatImgUrl(item.src, this.props.webpSupport)} alt="" />
                      </div>
                    ) :
                    (
                      <div
                        ref={ele => {
                          if (ele) {
                            this.props.exp && this.props.exp(ele);
                          }
                        }}
                        data-dot={JSON.stringify(utils.getExposureData(this.props, {
                          link: item.href,
                          type: baseConfig.sortType,
                          name: item.title,
                          sort: index
                        }))}
                        className="preview-drag-item"
                        onClick={this.handleItemClick.bind(this, index, item)}
                        style={{
                          width: `${width}px`,
                          height: `${height}px`,
                          zIndex: index + 100,
                        }}
                      >
                        {item.src && (<img className="item-img" src={utils.formatImgUrl(item.src, this.props.webpSupport)} alt="" />)}
                      </div>
                    )
                  }
                </Draggable>
                { 
                  targetModal &&
                  <PipelineModal
                    customAttributes={{
                      "data-component-id": targetModal.id,
                      "data-component-name": targetModal.name,
                      "data-component-block": targetModal.blockName,
                    }}
                    config={targetModal.data}
                    triggerId={this.props['customAttributes']["data-component-id"]}
                    visible={modalVisibles[index]}
                    onClose={() => {
                      modalVisibles[index] = false
                      this.setState({
                        modalVisibles
                      })
                    }}
                  />
                }
              </div>
            );
          })
        }
      </div>
    )
  }

  // 轮播热区
  renderSwiperHotMap() {
    const screenW = typeof window !== 'undefined' && window.innerWidth;
    const { baseConfig, swiperDrag = {} } = this.props.config;
    let { width, height, left, top } = swiperDrag;
    left = (left / 375) * screenW;
    top = (top / 375) * screenW;
    return (
      <div className="drag-editor-container">
        <div style={{width: '100%', height: '100%'}}>
          <Draggable
            disabled={!this.state.dragMode}
            defaultPosition={{ x: Number(left), y: Number(top) }}
            bounds="parent"
            handle=".handle"
            onStop={this.handleDragEnd.bind(this, 'swiper', null)}
          >
            {this.state.dragMode ?
              (
                <div
                  className="edit-drag-item"
                  style={{
                    width: px2rem(`${width}px`),
                    height: px2rem(`${height}px`),
                    zIndex: 100,
                    borderColor: baseConfig.dragFrameColor
                  }}
                  onClick={this.handleItemResize.bind(this, 'swiper', null)}
                >
                  <div className="handle"></div>
                  { this.renderSwiper() }
                </div>
              ) :
              (
                <div
                  className="preview-drag-item"
                  style={{
                    width: px2rem(`${width}px`),
                    height: px2rem(`${height}px`),
                    zIndex: 100,
                  }}
                >
                  { this.renderSwiper() }
                </div>
              )
            }
          </Draggable>
        </div>
      </div>
    )
  }

  // 图片轮播
  renderSwiper() {
    const { itemList } = this.props.config;
    return (
      <div className="swiper-container" ref={ref => this.swiperRef = ref}>
        <div className="swiper-wrapper">
          {
            itemList.map((item, index) => {
              return (
                <div className="swiper-slide" key={`slide-${index}`}>
                  <img src={item.src} alt="" />
                </div>
              )
            })
          }
        </div>
      </div>
    )
  }

  render() {
    const { isIframe } = this.state
    const { baseConfig, componentSize = {} } = this.props.config;
    const { width, height } = utils.getAdaptImageSize(componentSize);

    return (
      <div
        className={baseConfig.isFixedBottom ? (this.isIphoneX ? "pipeline-imgHotMap fixed iphoneX" : "pipeline-imgHotMap fixed") : "pipeline-imgHotMap"}
        id={this.props['customAttributes']['data-component-id']}
        name={baseConfig.title}
        {...this.props['customAttributes']}
        style={{
          paddingTop: baseConfig.moduleMarginTop >= 0 ? `${baseConfig.moduleMarginTop}px` : 0,
          marginTop: baseConfig.moduleMarginTop < 0 ? `${baseConfig.moduleMarginTop}px` : 0,
          marginLeft: `${baseConfig.moduleMarginHorizon}px`,
          marginRight: `${baseConfig.moduleMarginHorizon}px`,
        }}
      >
        {baseConfig.showTitle && (
          <div>
            <div className="title" style={{ color: baseConfig.titleColor }}>
              {baseConfig.title}
            </div>
          </div>
        )}
        {baseConfig.bannerImg && (
          <img
            className="banner-img"
            onClick={this.productBannerGo.bind(this, baseConfig.bannerLink)}
            src={utils.formatImgUrl(baseConfig.bannerImg, this.props.webpSupport)}
            alt=""
          />
        )}
        <div className="hot-map-editor">
          <LazyLoadImage
            className="bg-img"
            width="100%"
            style={{
              width: "100%",
              height: 'auto'
            }}
            visibleByDefault={isIframe}
            src={utils.formatImgUrl(baseConfig.bgImg, this.props.webpSupport)}
          />
          {
            baseConfig.openSwiper === '是'
              ? this.renderSwiperHotMap()
              : this.renderNormalHotMap()
          }
        </div>
      </div>
    );
  }
}

PipelineImgHotMap.propTypes = {
  config: PropTypes.object.isRequired,
};

export { PipelineImgHotMap };
export default PipelineImgHotMap;



// WEBPACK FOOTER //
// ./components/pipeline-imgHotMap/index.js